<template>
    <div class="col-12 fiber-contact-success">

      <div class="row">
        <div class="col-12">
          
          <div class="alert-success d-flex my-3 mt-4">
            <div>
              <h1 class="pt-1">{{ $t('Thank you! Your request has been sent') }}</h1>
            </div>
            <span class="alert-icon ml-3"><span class="sr-only">Success</span></span>
          </div>

        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <p style="font-size: 16px;">{{ $t('An advisor will call you back to verify your eligibility within 48 hours') }}</p>
        </div>
      </div>
      
      <div class="row">
        <div class="col-12 mt-4 mb-2 py-1">
          <h3 style="font-size: 26px;">{{ $t('Want to chat with us now?') }}</h3>
        </div>
      </div>
        

      <div class="row">
        <div class="contactSuccessImage col-12 col-sm-6 col-xl-5">
          <div class="img mb-3">
            <img :src="getImgLink" alt="">
          </div>

          <div class="buttons-group row">
            <div class="col-6 col-md-4 pr-md-2 idz_btn_fix">
              <div
                id="iadvize-btn-success-page-offline"
                class="btn btn-primary u-full-width u-block">
                  {{ $t('Chat live') }}
              </div>
              <div
                id="iadvize-btn-success-page-online"
                class="btn btn-primary u-full-width u-block"
                style="display: none">
                  {{ $t('Chat live') }}
              </div>
              <div
                id="iadvize-btn-success-page-busy"
                class="btn btn-primary u-full-width u-block"
                style="display: none">
                  {{ $t('Chat live') }}
              </div>
            </div>
    
            <div class="col-6 col-md-4 px-md-2 idz_btn_fix">
              <div
                id="iadvize-btn-success-page-call-offline"
                class="btn btn-primary u-full-width u-block">
                {{ $t('Call me back') }}
              </div>
              <div
                id="iadvize-btn-success-page-call-online"
                class="btn btn-primary u-full-width u-block"
                style="display: none">
                {{ $t('Call me back') }}
              </div>
              <div
                id="iadvize-btn-success-page-call-busy"
                class="btn btn-primary u-full-width u-block"
                style="display: none">
                {{ $t('Call me back') }}
              </div>
            </div>
    
            <div class="col-12 mt-3 mt-md-0 col-md-4 pl-md-2">
              <a
                :href="getLink"
                class="btn btn-secondary u-full-width u-block">
                {{ $t('Find a shop') }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  export default {
    props: {
      traduction: {
        type: Function
      }
    },
    computed: {
      $t () {
        return this.traduction
      },
      getImgLink(){
        return window.planDataFromMagento.contactImgUrl
      },
      getLink(){
        const shopLink = window.planDataFromMagento.locale == 'en' ? 'en/store-locator/' : 'fr/trouver-un-shop/'
        return window.location.origin + '/' + shopLink
      }
    }
}
</script>

